interface ToastProps {
  message: string;
  visible: boolean;
}

export function Toast({ message, visible }: ToastProps) {
  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 px-4 py-3 rounded-lg transition-opacity duration-300 pointer-events-none"
      style={{
        backgroundColor: 'var(--surface-container-highest)',
        borderColor: 'var(--outline-variant)',
        color: 'var(--text-primary)',
        border: '1px solid var(--outline-variant)',
        opacity: visible ? 1 : 0,
      }}
    >
      <span className="material-symbols-outlined text-[18px]" style={{ color: 'var(--color-success, #107c10)' }}>
        check_circle
      </span>
      <span className="text-sm font-medium">{message}</span>
    </div>
  );
}
